module.exports = __webpack_public_path__ + "assets/img/img41.47085242.png";